import { render } from "./TabNav2.vue?vue&type=template&id=8dff3fb0"
import script from "./TabNav2.vue?vue&type=script&lang=js"
export * from "./TabNav2.vue?vue&type=script&lang=js"

import "./TabNav2.vue?vue&type=style&index=0&id=8dff3fb0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__